import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/home_img1.png';
import _imports_1 from '../../assets/jingdong.png';
import _imports_2 from '../../assets/taobao.png';
import _imports_3 from '../../assets/douyin_logo.png';
import _imports_4 from '../../assets/douyin_img.png';
import _imports_5 from '../../assets/airpay.png';
import _imports_6 from '../../assets/airpay_img.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-2e29e5f0"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "topbar"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "topBtn_text"
  }, "购买方式", -1);
});

var _hoisted_3 = [_hoisted_2];

var _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"page\" id=\"content\" data-v-2e29e5f0><div class=\"top1\" data-v-2e29e5f0><div class=\"top1_text\" data-v-2e29e5f0>购买连接</div><div class=\"top1_block\" data-v-2e29e5f0></div><div class=\"top1_abs\" data-v-2e29e5f0>Purchase link</div></div></div>", 1);

var _hoisted_5 = {
  class: "top2"
};

var _hoisted_6 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_0 + "\" class=\"top2_fengmian\" data-v-2e29e5f0><div class=\"top2_block2\" data-v-2e29e5f0><div class=\"top2_block2_title\" data-v-2e29e5f0> BC60水墨屏电子阅读器 </div><div class=\"top2_block2_abs\" data-v-2e29e5f0> 类纸全新阅读体验 </div><div style=\"display:flex;margin-top:32px;\" data-v-2e29e5f0><div class=\"line\" data-v-2e29e5f0></div><div class=\"line\" data-v-2e29e5f0></div><div class=\"line\" data-v-2e29e5f0></div></div><div style=\"margin-top:45px;display:flex;align-items:center;position:relative;\" data-v-2e29e5f0><div class=\"top2_circle\" data-v-2e29e5f0></div><div class=\"top2_clrcle_text\" data-v-2e29e5f0>阅读数据智能检测分析</div><div class=\"line2\" data-v-2e29e5f0></div></div><div style=\"margin-top:35px;display:flex;align-items:center;position:relative;\" data-v-2e29e5f0><div class=\"top2_circle\" data-v-2e29e5f0></div><div class=\"top2_clrcle_text\" data-v-2e29e5f0>水墨屏呵护视力健康</div><div class=\"line2\" data-v-2e29e5f0></div></div><div style=\"margin-top:35px;display:flex;align-items:center;position:relative;\" data-v-2e29e5f0><div class=\"top2_circle\" data-v-2e29e5f0></div><div class=\"top2_clrcle_text\" data-v-2e29e5f0>类纸全新阅读体验</div><div class=\"line2\" data-v-2e29e5f0></div></div><div style=\"margin-top:35px;display:flex;align-items:center;position:relative;\" data-v-2e29e5f0><div class=\"top2_circle\" data-v-2e29e5f0></div><div class=\"top2_clrcle_text\" data-v-2e29e5f0>机身小巧轻薄随声携带-随时阅读</div><div class=\"line2\" data-v-2e29e5f0></div></div><div style=\"margin-top:35px;display:flex;align-items:center;position:relative;\" data-v-2e29e5f0><div class=\"top2_circle\" data-v-2e29e5f0></div><div class=\"top2_clrcle_text\" data-v-2e29e5f0>配套软件内置海量图书免费畅读-随时阅读</div></div></div>", 2);

var _hoisted_8 = {
  class: "top2_block"
};

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "top2_img"
  }, null, -1);
});

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "top2_text"
  }, "中少百城旗舰店", -1);
});

var _hoisted_11 = [_hoisted_9, _hoisted_10];

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "top2_img2"
  }, null, -1);
});

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "top2_text2"
  }, "易连聚旗舰店", -1);
});

var _hoisted_14 = [_hoisted_12, _hoisted_13];

var _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"douStore\" data-v-2e29e5f0><img src=\"" + _imports_3 + "\" class=\"top2_img3\" data-v-2e29e5f0><div class=\"top2_text3\" data-v-2e29e5f0>百城电子墨水屏阅读</div><img src=\"" + _imports_4 + "\" class=\"douyinhover animated fadeInDown\" data-v-2e29e5f0></div><div class=\"airPay\" data-v-2e29e5f0><img src=\"" + _imports_5 + "\" class=\"top2_img2\" data-v-2e29e5f0><div class=\"top2_text4\" data-v-2e29e5f0> 百城电子墨水屏阅读</div><img src=\"" + _imports_6 + "\" class=\"airpayhover animated fadeInDown\" data-v-2e29e5f0></div>", 2);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.handleGuige && _ctx.handleGuige.apply(_ctx, arguments);
    })
  }, [_createElementVNode("div", {
    to: "/introduction",
    class: _normalizeClass(_ctx.index == 1 ? 'bar1' : 'active')
  }, "参考规格", 2)]), _createElementVNode("div", {
    onClick: _cache[1] || (_cache[1] = function () {
      return _ctx.handleRuanjian && _ctx.handleRuanjian.apply(_ctx, arguments);
    })
  }, [_createElementVNode("div", {
    to: "/software",
    class: _normalizeClass(_ctx.index == 2 ? 'bar1' : 'active')
  }, "配套软件", 2)]), _createElementVNode("div", {
    class: "topBtn",
    onClick: _cache[2] || (_cache[2] = function () {
      return _ctx.handleBuy && _ctx.handleBuy.apply(_ctx, arguments);
    })
  }, _hoisted_3)]), _hoisted_4, _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
    style: {
      "display": "flex",
      "flex-direction": "column",
      "align-items": "center",
      "margin-top": "43px",
      "cursor": "pointer"
    },
    onClick: _cache[3] || (_cache[3] = function () {
      return _ctx.gotobuy1 && _ctx.gotobuy1.apply(_ctx, arguments);
    })
  }, _hoisted_11), _createElementVNode("div", {
    style: {
      "display": "flex",
      "flex-direction": "column",
      "align-items": "center",
      "margin-top": "29px",
      "cursor": "pointer"
    },
    onClick: _cache[4] || (_cache[4] = function () {
      return _ctx.gotobuy2 && _ctx.gotobuy2.apply(_ctx, arguments);
    })
  }, _hoisted_14), _hoisted_15])])], 64);
}